import personnelEditModel from './personnelEditModel.vue';
import { getPersonnelDetailList, personnelDetailsExport } from '../request.js';
import { isCardNo } from '@/utils/validate';
import batchListModel from './batchListModel.vue';
import { downloadFileFun } from '@/utils/public';
export default {
  components: {
    personnelEditModel,
    batchListModel
  },
  data() {
    return {
      form: {
        policyStatus: undefined,
        name: '',
        idNumber: '',
        correctEffectiveTime: [],
        remark: ''
      },
      insuranceState: [{
        label: '待生效',
        value: 'PENDING'
      }, {
        label: '保障中',
        value: 'EFFECTIVE'
      }, {
        label: '退保中',
        value: 'CANCEL'
      }, {
        label: '已退保',
        value: 'CANCELED'
      }, {
        label: '已过期',
        value: 'EXPIRED'
      }],
      dialogVisible: false,
      importVisible: false,
      columns: [{
        slots: {
          title: '工种'
        },
        dataIndex: 'occupation',
        key: 'occupation',
        align: 'center'
      }, {
        slots: {
          title: '姓名'
        },
        dataIndex: 'name',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '证件类型'
        },
        dataIndex: 'identificationType',
        key: 'identificationType',
        align: 'center'
      }, {
        slots: {
          title: '证件号码'
        },
        dataIndex: 'idNumber',
        key: 'idNumber',
        align: 'center'
      }, {
        slots: {
          title: '保单状态'
        },
        dataIndex: 'policyStatus',
        scopedSlots: {
          customRender: 'policyStatus'
        },
        key: 'policyStatus',
        align: 'center'
      }, {
        slots: {
          title: '责任起期'
        },
        dataIndex: 'startAt',
        key: 'startAt',
        align: 'center'
      }, {
        slots: {
          title: '责任止期'
        },
        dataIndex: 'endAt',
        key: 'endAt',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 250,
        key: '9'
      }],
      data: [],
      editInfo: {},
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `共 ${total} 条`;
        }
      },
      loading: false,
      personEditVisible: false,
      batchListVisible: false
    };
  },
  created() {
    this.searchFun();
  },
  methods: {
    cancelImport() {
      this.importVisible = false;
    },
    searchFun() {
      this.pagination.current = 1;
      this.getList();
    },
    getList() {
      var _this$form$idNumber;
      if (this.form.idNumber && !isCardNo((_this$form$idNumber = this.form.idNumber) === null || _this$form$idNumber === void 0 ? void 0 : _this$form$idNumber.trim())) {
        this.$message.error(this.$t('身份证号有误'));
        return;
      }
      const {
        name,
        idNumber,
        policyStatus,
        remark,
        correctEffectiveTime
      } = this.form;
      let obj = {
        policyId: this.$route.params.id,
        name: name.trim(),
        idNumber: idNumber.trim(),
        policyStatus,
        remark: (remark === null || remark === void 0 ? void 0 : remark.trim()) || '',
        startAt: (correctEffectiveTime === null || correctEffectiveTime === void 0 ? void 0 : correctEffectiveTime.join('、')) || '',
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      this.data = [];
      this.pagination.total = 0;
      getPersonnelDetailList(obj).then(res => {
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    resetFun() {
      this.$refs.dataform.resetFields();
      this.searchFun();
    },
    personnelEntry() {
      this.dialogVisible = true;
    },
    batchEntry() {
      this.importVisible = true;
    },
    agencyFun() {},
    cancelModel() {
      this.dialogVisible = false;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getList();
    },
    editPersonnel(record) {
      this.personEditVisible = true;
      this.editInfo = record;
    },
    toBatchList() {
      this.batchListVisible = true;
    },
    personnelExport() {
      const h = this.$createElement;
      const that = this;
      this.loading = true;
      personnelDetailsExport({
        policyId: this.$route.params.id
      }).then(res => {
        if (res.status === 200) {
          this.$confirm({
            icon: () => h("a-icon", {
              "attrs": {
                "type": "check-circle",
                "theme": "twoTone"
              }
            }),
            title: this.$t('导出提示'),
            content: that.$t('导出任务已生成，请稍后查看导出附件'),
            okText: that.$t('确认'),
            cancelText: that.$t('取消'),
            onOk() {}
          });
          let fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[2].split('=')[1].replace(/^\"|\"$/g, '').replace(/utf-8''/, ''));
          downloadFileFun(res.data, 'application/vnd.ms-excel', fileName);
        }
      }).then(() => {
        this.loading = false;
      });
    }
  }
};